export default [

     // *--------- RAILWAY --------------------------------*
    {
        path: '/railway-structure/railway/list',
        name: 'railway_structure-railway-list',
        component: () => import('@/views/apps/railway_structure/railway/views/List.vue'),
        meta: {
            resource: 'railway',
            action: 'read',
            pageTitle: 'Железные дороги',
            breadcrumb: [
                {
                  text: 'Структура ЖД',
                    active: true,
                },
                {
                  text: 'Железные дороги',
                  active: true,
                },
            ],
        },
    },
    {
        path: '/railway-structure/railway/view/:id',
        name: 'railway_structure-railway-view',
        component: () => import('@/views/apps/railway_structure/railway/views/Details.vue'),
        meta: {
            resource: 'railway',
            action: 'read',
            pageTitle: 'Железные дороги',
            breadcrumb: [
                {
                  text: 'Структура ЖД',
                    active: true,
                },
                {
                  text: 'Железные дороги',
                    to: { name: 'railway_structure-railway-list' }
                },
                {
                  text: 'Детали',
                    active: true
                },
            ],
        },
    },
]
